export const getOrthophotoFields = (translate, hasCrudFeature) => [
  {
    label: translate('master.orthophoto.fields.layer'),
    key: 'layer',
    isSortable: false,
    shown: hasCrudFeature,
  },
  {
    label: translate('master.orthophoto.fields.filename'),
    key: 'label',
    isSortable: true,
    thStyle: 'width: 400px',
    editable: hasCrudFeature,
    validation: [['required']],
  },
  {
    label: translate('master.orthophoto.fields.status'),
    key: 'status',
    isSortable: true,
    shown: hasCrudFeature,
  },
  {
    label: translate('master.orthophoto.fields.uploadedAt'),
    key: 'createdAt',
    isSortable: true,
  },
  {
    label: translate('master.orthophoto.fields.uploadedBy'),
    key: 'creator.fullname',
    isSortable: false,
    shown: hasCrudFeature,
  },
  {
    label: translate('master.orthophoto.fields.autoZoom'),
    key: 'autoZoom',
    isSortable: true,
    thStyle: 'width: 100px',
  },
]
